export const getLastArrayItem = (arr: any[]): any => arr[arr.length - 1];
